// Accept both API attributes (snake_case) and message component props (camelCase).
// A patient's response or quoted automation must always remain a normal message.
export const isAutomationMessage = message => {
  const type = message.messageType ?? message.message_type;
  if (message.private || ![1, 3, 'outgoing', 'template'].includes(type)) return false;
  const content = message.contentAttributes ?? message.content_attributes ?? {};
  const additional = message.additionalAttributes ?? message.additional_attributes ?? {};
  return Boolean(
    content.automationRuleId || content.automation_rule_id ||
    additional.automationDelivery === true || additional.automation_delivery === true ||
    additional.campaignId || additional.campaign_id ||
    (additional.scheduledBy ?? additional.scheduled_by)?.type === 'AutomationRule'
  );
};

export const canCollapseAutomation = message =>
  isAutomationMessage(message) &&
  ['sent', 'delivered', 'read'].includes(message.status) &&
  !(message.contentAttributes ?? message.content_attributes)?.externalError &&
  !(message.contentAttributes ?? message.content_attributes)?.external_error;
